import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import {
  deleteConceptoDeAcreditacion,
  getConceptosDeAcreditacion,
  patchConceptoDeAcreditacion,
  postConceptoDeAcreditacion,
} from 'api/catalogos/conceptosDeAcreditacion';

// eslint-disable-next-line react/prop-types
const ConceptosDeAcreditacion = ({ permission }) => (
  <PlainCRUD
    title="Concepto de Acreditacion"
    customModalWidth={535}
    permission={permission}
    get={getConceptosDeAcreditacion}
    post={postConceptoDeAcreditacion}
    patch={patchConceptoDeAcreditacion}
    delete={deleteConceptoDeAcreditacion}
    fields={[
      defaultFields.clave,
      defaultFields.descripcion,
    ]}
  />
);

export default ConceptosDeAcreditacion;
